import { useNavigate } from 'react-router-dom'
import { Button, Flex, Tag, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { path } from 'src/libs/path'
import {
  useBudgetListTeam,
  useBudgetListOwn,
  useBudgetPeriod,
  useBudgetPeriodGate,
} from 'src/pages/budget/budgetRequests/hooks'
import { RequestListSection } from 'src/pages/budget/budgetRequests/section'
import {
  ModalRequestsDelete,
  BudgetPeriod,
  ModalRequestsToSubmit,
  ModalRequestsApprove,
  ModalRequestsReject,
  TableSkeleton,
  RowSkeleton,
  ModalRequestView,
  ModalRequestsCopy,
  ButtonChangeStatus,
  ButtonCreateBudget,
  ModalRequestsRejectSeo,
} from 'src/pages/budget/budgetRequests/components'
import { useUserProfile } from 'src/features/user'
import { useCeoTeam } from 'src/pages/budget/hook'
import { STATUS_PERIOD } from 'src/pages/budget/const'
import { ModalRequestComment } from 'src/pages/budget/budgetRequests/components/modalRequestComment'


export const BudgetRequests = () => {
  useBudgetPeriodGate()
  const navigate = useNavigate()

  const { budgetPeriod, loadingBudgetPeriodList } = useBudgetPeriod()
  const { currentPeriodId, byId } = budgetPeriod
  const currentPeriodStatus =
    currentPeriodId && byId.get(currentPeriodId)?.status!
  const isOutOfBudgetRequest =
    currentPeriodStatus !== STATUS_PERIOD.OPEN_CREATE
  const { loading: loadingBudgetListForApprove } = useBudgetListTeam()
  const { loading: loadingBudgetListOwn } = useBudgetListOwn()

  const { ceoTeam } = useCeoTeam()
  const userProfile = useUserProfile()
  const { Title } = Typography


  return (
    <Flex vertical gap="middle">
      <Flex justify="space-between" align="center">
        <Title level={1} style={{ marginBottom: 0 }}>
          Заявки на бюджет
        </Title>
        <Flex gap={16}>
          {ceoTeam.includes(userProfile.id) &&
            (budgetPeriod.byId.size === 0 ? (
              <ButtonCreateBudget />
            ) : (
              <ButtonChangeStatus budgetPeriod={budgetPeriod} />
            ))}
          {currentPeriodStatus !== STATUS_PERIOD.CLOSED &&
            budgetPeriod.byId.size !== 0 && (
            <Button
              size="large"
              color="geekblue"
              variant={isOutOfBudgetRequest ? 'outlined' : 'solid'}
              icon={<PlusOutlined />}
              iconPosition="start"
              key="button_add_budget_request"
              onClick={() =>
                navigate(path.budget.budgets.create(currentPeriodId))
              }
            >
              {isOutOfBudgetRequest ? 'Заявка вне бюджета' : 'Новая заявка'}
            </Button>
          )}
        </Flex>
      </Flex>

      {loadingBudgetPeriodList ? (
        <RowSkeleton />
      ) : budgetPeriod.byId.size === 0 ? (
        <Tag style={{ fontSize: 16, padding: 6, alignSelf: 'flex-start' }}>
          Нет доступных периодов
        </Tag>
      ) : (
        <BudgetPeriod budgetPeriod={budgetPeriod} />
      )}

      {loadingBudgetListForApprove || loadingBudgetListOwn ? (
        <TableSkeleton />
      ) : (
        <RequestListSection budgetPeriod={budgetPeriod} />
      )}
      <ModalRequestView />
      <ModalRequestsApprove />
      <ModalRequestsToSubmit />
      <ModalRequestsDelete />
      <ModalRequestsReject />
      <ModalRequestsCopy />
      <ModalRequestComment />
      <ModalRequestsRejectSeo />
    </Flex>
  )
}
